import React from "react";
import { Icons, IconButton } from "@storybook/components";
import { styled } from "@storybook/theming";
export default function OverlayButtons(props) {
    const { onToggleOverlay, onToggleLock, onToggleDifference, overlayIsOpen, overlayIsLocked, showDifference, } = props;
    const additionalOptions = overlayIsOpen && (React.createElement(React.Fragment, null,
        React.createElement(ToggleIconButton, { active: overlayIsLocked, className: "iconButton", title: overlayIsLocked ? "Unlock overlay" : "Lock overlay", onClick: onToggleLock },
            React.createElement(Icons, { icon: overlayIsLocked ? "lock" : "unlock" })),
        React.createElement(ToggleIconButton, { active: showDifference, className: "iconButton", title: "Show difference", onClick: onToggleDifference },
            React.createElement(Icons, { icon: "mirror" }))));
    return (React.createElement(Container, null,
        React.createElement(ToggleIconButton, { active: overlayIsOpen, className: "iconButton", title: overlayIsOpen ? "Hide overlay" : "Show overlay", onClick: onToggleOverlay },
            React.createElement(Icons, { icon: overlayIsOpen ? "eyeclose" : "eye" })),
        additionalOptions));
}
const Container = styled.div `
    display: flex;
    button {
        margin-right: 15px;
    }
`;
const ToggleIconButton = styled(IconButton) `
    color: ${props => props.active ? props.theme.barSelectedColor : props.theme.barTextColor}
`;
